export class Office {
    ID:number;
CLIENT_ID:number;
NAME:string;
POST:string;
DEPARTMENT:string;
MOBILE_NUMBER:string;
SEQUENCE_NO:number;
STATUS:boolean;

}